import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map, catchError, throwError } from 'rxjs';
import { environment } from '@env/environment';

export interface FirebaseSignupResponse {
  idToken: string;
  email: string;
  refreshToken: string;
  expiresIn: string;
  localId: string;
}

export interface FirebaseSigninResponse {
  displayName: string;
  email: string;
  expiresIn: string;
  idToken: string;
  localId: string;
  refreshToken: string;
  registered: boolean;
}

export interface FirebaseRefreshResponse {
  id_token: string;
  user_id: string;
  token_type: string;
  refresh_token: string;
  expires_in: string;
}

@Injectable({
  providedIn: 'root'
})
export class FirebaseAuthService {
  private readonly http = inject(HttpClient);

  /**
   * Inscription Firebase pure
   */
  signup(email: string, password: string): Observable<FirebaseSignupResponse> {
    console.log('🔥 FIREBASE: Inscription...');
    const url = `https://identitytoolkit.googleapis.com/v1/accounts:signUp?key=${environment.firebaseConfig.apiKey}`;
    const body = { email, password, returnSecureToken: true };

    return this.http.post<FirebaseSignupResponse>(url, body).pipe(
      map((response) => {
        console.log('✅ FIREBASE: Inscription réussie pour:', response.email);
        return response;
      }),
      catchError((error) => {
        console.error('❌ FIREBASE: Erreur inscription:', error);
        return throwError(() => error);
      })
    );
  }

  /**
   * Connexion Firebase pure
   */
  signin(email: string, password: string): Observable<FirebaseSigninResponse> {
    console.log('🔥 FIREBASE: Connexion...');
    const url = `https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=${environment.firebaseConfig.apiKey}`;
    const body = { email, password, returnSecureToken: true };

    return this.http.post<FirebaseSigninResponse>(url, body).pipe(
      map((response) => {
        console.log('✅ FIREBASE: Connexion réussie pour:', response.email);
        return response;
      }),
      catchError((error) => {
        console.error('❌ FIREBASE: Erreur connexion:', error);
        return throwError(() => error);
      })
    );
  }

  /**
   * Refresh du token Firebase
   */
  refreshToken(refreshToken: string): Observable<FirebaseRefreshResponse> {
    console.log('🔄 FIREBASE: Refresh token...');
    const url = `https://securetoken.googleapis.com/v1/token?key=${environment.firebaseConfig.apiKey}`;
    const body = new URLSearchParams();
    body.set('grant_type', 'refresh_token');
    body.set('refresh_token', refreshToken);

    return this.http.post<FirebaseRefreshResponse>(url, body.toString(), {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).pipe(
      map((response) => {
        console.log('✅ FIREBASE: Token refreshé avec succès');
        return response;
      }),
      catchError((error) => {
        console.error('❌ FIREBASE: Erreur refresh token:', error);
        return throwError(() => error);
      })
    );
  }

  /**
   * Déconnexion (nettoyage local uniquement)
   */
  signout(): void {
    console.log('🔥 FIREBASE: Déconnexion');
    // Firebase REST API n'a pas d'endpoint de déconnexion
    // La déconnexion se fait côté client en supprimant les tokens
  }
}